export default __webpack_public_path__ + "static/media/h6.0a82c046.PNG";